<template>
    <div class="logout">
        <button type="button" class="btn btn-blue btn-logout" @click="logout">{{ $t('auth.logout_title') }}</button>
    </div>
</template>


<script>
    export default {
        methods: {
            async logout(){
                await this.$store.dispatch('logout').then(() => this.$router.push('/sign-in'))
            }
        }
    }
</script>